import habo from 'habo';
import {createApp} from 'vue';
// 文档地址：https://fe.baijia.com/habo/#/perf

habo.setConfig({
    // habo@2.0.0 版本后，启用了独立域名的方式，DOMAIN 字段默认固定为 i.gsxtj.com。
    // DOMAIN: process.env.bigData,
    NAME: 'fh-read-m',
    VERB: 'get',
    DELAY: false,
});

habo.haboPerf = (obj:any, callback:any) => {
    habo.perf(obj, callback);
};
createApp().config.globalProperties.$habo = habo;
